<script lang="ts" setup>
import Desktop from '@/components/desktop/pages/promotion/index.vue'
import Mobile from '@/components/mobile/pages/promotion/index.vue'
import { usePageByDevice } from '~/composables/common/use-page-by-device'
const { component } = usePageByDevice(Desktop, Mobile)
</script>

<template>
  <div>
    <component :is="component" />
  </div>
</template>
